var WISHLIST_KEY = 'hs_wishlist';

// --- i18n: loaded from Liquid JSON block, German fallbacks ---
var _i18n = {
  addedToCart: 'Hinzugef\u00fcgt \u2713',
  error: 'Fehler',
  addToCart: 'In den Warenkorb',
  soldOut: 'Ausverkauft',
  removeItem: 'Entfernen',
  productsRemoved: 'nicht mehr verf\u00fcgbar und entfernt',
  variantUnavailable: 'Variante nicht mehr verf\u00fcgbar'
};
try {
  var _i18nEl = document.getElementById('wishlist-i18n');
  if (_i18nEl) Object.assign(_i18n, JSON.parse(_i18nEl.textContent));
} catch (e) { /* keep fallbacks */ }

function escapeHtml(str) {
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

// localStorage obfuscation (not encryption \u2014 handles are public data, just not plaintext readable)
function obfuscate(str) {
  try { return btoa(unescape(encodeURIComponent(str))); } catch (e) { return str; }
}
function deobfuscate(str) {
  try { return decodeURIComponent(escape(atob(str))); } catch (e) { return str; }
}

function getWishlist() {
  try {
    var raw = localStorage.getItem(WISHLIST_KEY) || '';
    if (!raw) return [];
    if (raw.startsWith('[')) return JSON.parse(raw);
    return JSON.parse(deobfuscate(raw));
  } catch (e) {
    return [];
  }
}

function saveWishlist(list) {
  try {
    localStorage.setItem(WISHLIST_KEY, obfuscate(JSON.stringify(list)));
  } catch (e) {
    console.warn('Wishlist save failed (storage quota?):', e.message);
  }
}

function parseEntry(entry) {
  var colon = entry.indexOf(':');
  if (colon === -1) return { handle: entry, variantId: null };
  return {
    handle: entry.slice(0, colon),
    variantId: entry.slice(colon + 1)
  };
}

function isLoggedIn() {
  return typeof window.__hs_customer !== 'undefined';
}

function fetchServerWishlist() {
  if (!isLoggedIn()) return Promise.resolve(null);
  return fetch('/apps/wishlist')
    .then(function(res) { return res.ok ? res.json() : null; })
    .then(function(data) { return data ? (data.handles || []) : null; })
    .catch(function() { return null; });
}

function saveServerWishlist(handles) {
  if (!isLoggedIn()) return;
  fetch('/apps/wishlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ handles: handles }),
  }).catch(function(err) { console.warn('Wishlist sync failed:', err.message); });
}

function mergeWishlists(local, server) {
  var set = new Set([].concat(local, server));
  return Array.from(set);
}

var _migrationDone = false;
function migrateWishlistEntries() {
  if (_migrationDone) return Promise.resolve();
  _migrationDone = true;
  var list = getWishlist();
  var legacyEntries = list.filter(function(e) { return e.indexOf(':') === -1; });
  if (legacyEntries.length === 0) return Promise.resolve();

  var migrated = list.slice();
  return Promise.all(
    legacyEntries.map(function(handle) {
      return fetch('/products/' + handle + '.json')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          if (!data || !data.product) return;
          var firstVariant = data.product.variants.find(function(v) { return v.available; })
            || data.product.variants[0];
          if (!firstVariant) return;
          var idx = migrated.indexOf(handle);
          if (idx !== -1) migrated[idx] = handle + ':' + firstVariant.id;
        })
        .catch(function() {});
    })
  ).then(function() {
    saveWishlist(migrated);
  });
}

function initProductPageVariantListener() {
  if (!window.productId || !window.FoxThemeEvents) return;
  window.FoxThemeEvents.subscribe(
    window.productId + '__VARIANT_CHANGE',
    function(variant) {
      var handle = window.productHandle
        || (document.querySelector('.wishlist-btn[data-product-handle]') || {}).dataset?.productHandle;
      if (!handle) return;
      var btn = document.querySelector('.wishlist-btn[data-product-handle="' + CSS.escape(handle) + '"]');
      if (!btn) return;
      btn.dataset.variantId = variant.id;
      updateWishlistButton(btn);
    }
  );
}

var _syncDone = false;
function syncWishlistOnLoad() {
  if (!isLoggedIn() || _syncDone) return;
  fetchServerWishlist().then(function(serverList) {
    if (!serverList) return;
    _syncDone = true;
    var local = getWishlist();
    var merged = mergeWishlists(local, serverList);
    if (merged.length !== local.length || merged.length !== serverList.length) {
      saveWishlist(merged);
      saveServerWishlist(merged);
      updateHeaderCount();
      document.querySelectorAll('.wishlist-btn[data-product-handle]').forEach(updateWishlistButton);
    }
  });
}

function isWishlisted(handle, variantId) {
  var list = getWishlist();
  if (variantId) return list.includes(handle + ':' + variantId);
  return list.some(function(entry) {
    return entry === handle || entry.startsWith(handle + ':');
  });
}

var _productCache = {};

// --- Klaviyo integration ---
function trackWishlistAdded(product, variant) {
  var _learnq = window._learnq || [];
  _learnq.push(['track', 'Added to Wishlist', {
    ProductName: product.title,
    ProductID: product.id,
    Handle: product.handle,
    VariantID: variant.id,
    VariantName: variant.title !== 'Default Title' ? variant.title : null,
    ImageURL: (product.images && product.images[0]) ? product.images[0].src : null,
    URL: window.location.origin + '/products/' + product.handle,
    Price: variant.price ? (Number(variant.price) / 100).toFixed(2) : null,
    CompareAtPrice: variant.compare_at_price ? (Number(variant.compare_at_price) / 100).toFixed(2) : null
  }]);
}

// Sync full wishlist to Klaviyo profile property (called when drawer loads with product data)
function syncWishlistToKlaviyo(productMap, entries) {
  var _learnq = window._learnq || [];
  var items = [];
  entries.forEach(function(entry) {
    var parsed = parseEntry(entry);
    var product = productMap[parsed.handle];
    if (!product) return;
    var variant = parsed.variantId
      ? (product.variants.find(function(v) { return String(v.id) === parsed.variantId; }) || product.variants[0])
      : product.variants[0];
    items.push({
      ProductName: product.title,
      Handle: product.handle,
      VariantID: variant ? String(variant.id) : null,
      ImageURL: (product.images && product.images[0]) ? product.images[0].src : null,
      URL: window.location.origin + '/products/' + product.handle,
      Price: variant && variant.price ? (Number(variant.price) / 100).toFixed(2) : null,
      Available: variant ? variant.available !== false : false
    });
  });
  _learnq.push(['identify', {
    WishlistCount: items.length,
    WishlistItems: items,
    WishlistLastUpdated: new Date().toISOString()
  }]);
}

// Lightweight count update (no product fetch needed — runs on every add/remove)
function syncWishlistCountToKlaviyo() {
  var _learnq = window._learnq || [];
  var count = getWishlist().length;
  _learnq.push(['identify', {
    WishlistCount: count,
    WishlistLastUpdated: new Date().toISOString()
  }]);
}

function fetchProduct(handle) {
  if (_productCache[handle]) return Promise.resolve(_productCache[handle]);
  return fetch('/products/' + handle + '.json')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (data && data.product) {
        _productCache[handle] = data.product;
        return data.product;
      }
      return null;
    })
    .catch(function() { return null; });
}

function toggleWishlist(handle, variantId) {
  if (!variantId) return false;
  var entry = handle + ':' + variantId;
  var list = getWishlist();
  var idx = list.indexOf(entry);
  if (idx === -1) {
    list.push(entry);
  } else {
    list.splice(idx, 1);
    delete _productCache[handle];
  }
  saveWishlist(list);
  saveServerWishlist(list);
  syncWishlistCountToKlaviyo();
  return idx === -1;
}

function updateWishlistButton(btn) {
  var handle = btn.dataset.productHandle;
  var variantId = btn.dataset.variantId || null;
  if (!handle) return;
  var active = isWishlisted(handle, variantId);
  btn.classList.toggle('wishlist-btn--active', active);
  btn.setAttribute('aria-label', active ? btn.dataset.labelRemove : btn.dataset.labelAdd);
  btn.setAttribute('aria-pressed', String(active));
  var textEl = btn.querySelector('.wishlist-btn__text');
  if (textEl) textEl.textContent = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
}

function updateHeaderCount() {
  var count = getWishlist().length;
  var el = document.getElementById('wishlist-drawer__count');
  if (el) el.textContent = count;
  var headerBtn = document.querySelector('.wishlist-btn--header');
  if (headerBtn) {
    headerBtn.classList.toggle('wishlist-btn--active', count > 0);
  }
}

function addToCart(variantId, btn) {
  var originalText = btn.textContent;
  btn.disabled = true;
  btn.classList.add('wishlist-drawer__atc--loading');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
  })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || _i18n.error); });
      return r.json();
    })
    .then(function() {
      btn.textContent = _i18n.addedToCart;
      btn.classList.add('wishlist-drawer__atc--done');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.classList.remove('wishlist-drawer__atc--done');
      }, 2500);
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('.f-cart-count');
        if (bubble) bubble.textContent = cart.item_count;
      });
    })
    .catch(function(err) {
      btn.textContent = err.message || _i18n.error;
      setTimeout(function() { btn.textContent = originalText; }, 2500);
    })
    .finally(function() {
      btn.disabled = false;
      btn.classList.remove('wishlist-drawer__atc--loading');
    });
}

function renderWishlistItem(product, entry) {
  var parsed = parseEntry(entry);
  var exactVariant = parsed.variantId
    ? product.variants.find(function(v) { return String(v.id) === parsed.variantId; })
    : null;
  var variantMissing = parsed.variantId && !exactVariant;
  var variant = exactVariant || product.variants[0];
  var img = (variant && variant.featured_image && variant.featured_image.src)
    ? variant.featured_image.src
    : (product.images && product.images[0] ? product.images[0].src : null);
  var available = !variantMissing && variant ? variant.available !== false : false;
  var variantId = !variantMissing && variant ? variant.id : null;
  var variantTitle = variantMissing
    ? _i18n.variantUnavailable
    : ((variant && variant.title && variant.title !== 'Default Title') ? variant.title : null);
  var variantClass = variantMissing
    ? 'wishlist-drawer__item-variant wishlist-drawer__item-variant--unavailable'
    : 'wishlist-drawer__item-variant';

  var li = document.createElement('li');
  li.className = 'wishlist-drawer__item';
  li.dataset.entry = entry;

  var html =
    '<a href="/products/' + encodeURIComponent(product.handle) + '" class="wishlist-drawer__item-image">' +
      (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title) + '" width="80" height="80" loading="lazy">' : '') +
    '</a>' +
    '<div class="wishlist-drawer__item-info">' +
      '<p class="wishlist-drawer__item-title">' +
        '<a href="/products/' + encodeURIComponent(product.handle) + '">' + escapeHtml(product.title) + '</a>' +
      '</p>' +
      (variantTitle ? '<p class="' + variantClass + '">' + escapeHtml(variantTitle) + '</p>' : '') +
    '</div>' +
    '<div class="wishlist-drawer__item-bottom">' +
      (available && variantId ? (
        '<button type="button" class="wishlist-drawer__atc btn btn--secondary btn--small" data-variant-id="' + variantId + '">' +
          '<svg class="wishlist-drawer__atc-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 21.75C8.32843 21.75 9 21.0784 9 20.25C9 19.4216 8.32843 18.75 7.5 18.75C6.67157 18.75 6 19.4216 6 20.25C6 21.0784 6.67157 21.75 7.5 21.75Z" fill="currentColor"/><path d="M17.25 21.75C18.0784 21.75 18.75 21.0784 18.75 20.25C18.75 19.4216 18.0784 18.75 17.25 18.75C16.4216 18.75 15.75 19.4216 15.75 20.25C15.75 21.0784 16.4216 21.75 17.25 21.75Z" fill="currentColor"/><path d="M3.96469 6.75H21L18.3262 15.4416C18.2318 15.7482 18.0415 16.0165 17.7833 16.207C17.5252 16.3975 17.2127 16.5002 16.8919 16.5H7.88156C7.55556 16.5001 7.23839 16.3941 6.97806 16.1978C6.71772 16.0016 6.5284 15.7259 6.43875 15.4125L3.04781 3.54375C3.00301 3.38711 2.90842 3.24932 2.77835 3.15122C2.64828 3.05311 2.4898 3.00003 2.32687 3H0.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<span class="wishlist-drawer__atc-text">' + escapeHtml(_i18n.addToCart) + '</span>' +
        '</button>'
      ) : '<span class="wishlist-drawer__sold-out">' + escapeHtml(_i18n.soldOut) + '</span>') +
      '<button type="button" class="wishlist-drawer__item-remove btn btn--underline" data-remove-entry="' + escapeHtml(entry) + '">' +
        '<span>' + escapeHtml(_i18n.removeItem) + '</span>' +
      '</button>' +
    '</div>';

  li.innerHTML = html;
  return li;
}

function loadWishlistDrawer() {
  if (!isLoggedIn()) return Promise.resolve();

  return migrateWishlistEntries().then(function() {
    var list = getWishlist();
    var itemsEl = document.getElementById('wishlist-drawer__items');
    var emptyEl = document.getElementById('wishlist-drawer__empty');
    var loadingEl = document.getElementById('wishlist-drawer__loading');
    var countEl = document.getElementById('wishlist-drawer__count');

    if (!itemsEl) return;

    if (countEl) countEl.textContent = list.length;

    if (list.length === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (loadingEl) loadingEl.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (loadingEl) loadingEl.hidden = false;
    itemsEl.innerHTML = '';

    var minLoadTime = new Promise(function(r) { setTimeout(r, 400); });

    var uniqueHandles = [];
    var seen = {};
    list.forEach(function(entry) {
      var h = parseEntry(entry).handle;
      if (!seen[h]) { seen[h] = true; uniqueHandles.push(h); }
    });

    var productMap = {};
    return Promise.all([
      minLoadTime,
      Promise.all(
        uniqueHandles.map(function(handle) {
          return fetchProduct(handle).then(function(product) {
            if (product) productMap[handle] = product;
          });
        })
      )
    ]).then(function() {
      if (loadingEl) loadingEl.hidden = true;

      var validEntries = list.filter(function(entry) {
        return productMap[parseEntry(entry).handle];
      });
      var removedCount = list.length - validEntries.length;
      if (removedCount > 0) {
        saveWishlist(validEntries);
        updateHeaderCount();
      }

      if (countEl) countEl.textContent = validEntries.length;

      if (validEntries.length === 0) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      if (removedCount > 0) {
        var notice = document.createElement('li');
        notice.className = 'wishlist-drawer__notice';
        notice.setAttribute('role', 'status');
        notice.textContent = removedCount + ' ' + _i18n.productsRemoved;
        itemsEl.appendChild(notice);
        setTimeout(function() { if (notice.parentNode) notice.remove(); }, 5000);
      }

      validEntries.forEach(function(entry) {
        var handle = parseEntry(entry).handle;
        var product = productMap[handle];
        if (product) itemsEl.appendChild(renderWishlistItem(product, entry));
      });

      // Sync full wishlist with product data to Klaviyo profile
      syncWishlistToKlaviyo(productMap, validEntries);
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.productHandle) {
    var initialInput = document.querySelector('.f-product-single__blocks input[name="id"]')
      || document.querySelector('.main-product-form input[name="id"]');
    if (initialInput && initialInput.value) {
      var productBtn = document.querySelector('.wishlist-btn[data-product-handle="' + window.productHandle + '"]');
      if (productBtn && !productBtn.dataset.variantId) {
        productBtn.dataset.variantId = initialInput.value;
      }
    }
  }

  if (isLoggedIn()) {
    document.querySelectorAll('.wishlist-btn[data-product-handle]').forEach(updateWishlistButton);
    updateHeaderCount();
    syncWishlistOnLoad();
  }

  initProductPageVariantListener();

  var drawer = document.getElementById('Drawer-Wishlist');
  if (drawer) {
    drawer.addEventListener('open', function() { loadWishlistDrawer(); });
  }

  document.addEventListener('click', function(e) {
    var atcBtn = e.target.closest('.wishlist-drawer__atc[data-variant-id]');
    if (!atcBtn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(atcBtn.dataset.variantId, atcBtn);
  });

  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.wishlist-drawer__item-remove[data-remove-entry]');
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var entry = removeBtn.dataset.removeEntry;
    var parsed = parseEntry(entry);
    var list = getWishlist();
    var idx = list.indexOf(entry);
    if (idx !== -1) {
      list.splice(idx, 1);
      saveWishlist(list);
      saveServerWishlist(list);
      syncWishlistCountToKlaviyo();
    }
    delete _productCache[parsed.handle];
    updateHeaderCount();
    document.querySelectorAll('.wishlist-btn[data-product-handle="' + CSS.escape(parsed.handle) + '"]').forEach(updateWishlistButton);
    loadWishlistDrawer();
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.wishlist-btn[data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!isLoggedIn()) {
      if (drawer) {
        drawer.openDrawer(btn);
      } else {
        window.location.href = '/account/login';
      }
      return;
    }
    var handle = btn.dataset.productHandle;
    var variantId = btn.dataset.variantId || null;
    if (!variantId) return;
    var added = toggleWishlist(handle, variantId);
    updateWishlistButton(btn);
    updateHeaderCount();
    if (added) {
      // Track Klaviyo event with product data
      fetchProduct(handle).then(function(product) {
        if (!product) return;
        var variant = product.variants.find(function(v) { return String(v.id) === variantId; }) || product.variants[0];
        if (variant) trackWishlistAdded(product, variant);
      });
      if (drawer) drawer.openDrawer(btn);
    }
  });
});
